import { z } from 'zod';


export const progressPaymentSchema = z.object({
    id: z.number().default(-1),
    total: z.number().default(0),
    percentToPay: z.number().default(0),
    valueToPay: z.number().default(0),
    numberOfContract: z.string().default(""),
    dateOfCommissioning: z.string().default(new Date().toISOString().split("T")[0]),
})
export type IProgressPayment = z.infer<typeof progressPaymentSchema>;